const Main = () => import(/* webpackChunkName: "autorizacao-bundle" */'./main.vue');

export default [
  {
    name: 'quimioterapias-anexo',
    path: '/quimioterapias-anexo',
    components: { default: Main },
    meta: {
      requiresAuth: true,
      breadcrum: 'Quimioterapia',
      icon: 'diagnoses',
      can: 'list',
      on: 'autorizacao',
    },
  },
];
